import { makeStyles } from '@material-ui/core/styles'
const useStyles = makeStyles(
  () => ({
    layout: {
      width: '16em',
      '@media (max-height: 800px), (max-width: 1400px)': {
        width: '14em',
      },
      height: '75px',
      // border: '2px solid black',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      alignItems: 'center',
      cursor: 'pointer',
    },
    formControl: {
      margin: '0px 10px 10px 10px',
      width: '100%',
      height: '35px',
    },
  }),
  { index: 1 },
)

export { useStyles }
